export const CONFIG = {
  itemsPerPageOptions: [
    { key: 20, text: "20 per page", value: 20 },
    { key: 30, text: "30 per page", value: 30 },
    { key: 50, text: "50 per page", value: 50 },
  ],
  statusColors: {
    paid: "green",
    resolved: "blue",
    waived: "orange",
    cancelled: "grey",
    active: "red",
    unpaid: "yellow",
  },
  baseFont: { fontFamily: "Arial, sans-serif", fontSize: "14px" },
  columnWidths: {
    patron: "180px",
    document: "220px",
    barcode: "120px",
    dueDate: "140px",
    daysOverdue: "100px",
    fineAmount: "100px",
    status: "100px",
    paymentRef: "140px",
  },
};

export const calculateDaysOverdue = (endDate, returnDate = null) => {
  const end = new Date(endDate);
  const compareDate = returnDate ? new Date(returnDate) : new Date();
  const diffDays = Math.ceil((compareDate - end) / (1000 * 60 * 60 * 24));
  return Math.max(0, diffDays);
};

export const getSortValue = (fine, column) => {
  const values = {
    patron_name: (fine.patron_name || "").toLowerCase(),
    document_title: (fine.document_title || "").toLowerCase(),
    item_barcode: fine.item_barcode || "",
    due_date: fine.due_date ? new Date(fine.due_date).getTime() : 0,
    days_overdue: fine.due_date
      ? calculateDaysOverdue(fine.due_date, fine.return_date)
      : 0,
    total_fine: parseFloat(fine.total_fine || 0),
  };
  return values[column] || "";
};

export const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);

export const formatDate = (dateString) =>
  dateString
    ? new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "-";
